const someTime: Function = window["iw"].utils.someTime;
const scrollToWithHeaderOffset: Function = window["iw"].layout.scrollToWithHeaderOffset;

declare const jQuery: any;
const $ = jQuery;

export async function initSupplierContactPopup(): Promise<void> {
    const $popup = $(`.hs-supplier-contact-popup`);
    if ($popup.length === 0) {
        return;
    }
    const id: string = $popup.attr("data-scroll-to-id");
    if (!id) {
        return;
    }
    const $container = $(document.getElementById(id));
    if ($container.length === 0) {
        return;
    }
    const closePopup = async () => {
        $popup.removeClass("show");
        await someTime(350);
        $popup.remove();
    };
    const delay: number = parseInt($popup.attr("data-delay"), 10);
    await someTime(delay);
    $popup.css({ display: "" });
    await someTime(25);
    $popup.addClass("show").on("click", function (event) {
        scrollToWithHeaderOffset($container);
        event.stopPropagation();
        closePopup();
        return false;
    });
    $popup.find(`[data-close]`).on("click", function (event) {
        event.stopPropagation();
        closePopup();
        return false;
    });
}
